module.exports = __webpack_public_path__ + "static/media/1.c6d68593.jpg";